import React from 'react';
import { connect, useSelector } from 'react-redux'
import { useState, useMemo, useEffect } from 'react'

import pageWithSideMenu from '../../../containers/pageWithSideMenu'
import pageContent from '../../../containers/pageContent'

import CardHeader from '../../../containers/CardHeader'
import Form from '../../../containers/Form/Form'
import Select from "../../../containers/Form/Select";

// import Moment from 'moment';
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import toolsAPICall from '../../../app/apiCalls/toolsAPICall'
import { tool_details, tool_bellacams, tool_bellacams_save } from "../../../app/apiEndpoints" //tool_lp_dashboard_boost
import DataTable from "../../../containers/DataTable";
import { Card, Row, Col, Breadcrumb, FormGroup, FormLabel } from 'react-bootstrap'
import { tableTypes } from '../../../app/settings'
import Input from '../../../containers/Form/Input';
import Button from '../../../containers/Form/Button';

import Moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//import { CSVLink } from "react-csv";


const BellaCamsTool = (props) => {
    const toolID = 26
    const [tool, setTool] = useState({})

    //const [hasErrors, setHasErrors] = useState(false)
    //const [status, setStatus] = useState(0)

    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)
    const isSysadmin = useSelector((state) => state.user.isSysadmin)

    const [stats, setStats] = useState([])

    const [inputValue, setInputValue] = useState({ modelID: 0, username: "", category: "", isActive: 1 });
    const [errors, setErrors] = useState({ modelID: "", username: "", category: "", isActive: "" });
    const { modelID, username, category, isActive } = inputValue;
    const [formMessage, setFormMessage] = useState('')
    const canEdit = isSysadmin

    //filters
    const [startDate, setStartDate] = useState(new Date(Moment().add(-1, 'days').format('MM/DD/YYYY')))
    const [endDate, setEndDate] = useState(new Date(Moment().format('MM/DD/YYYY')))
    const tableFields = ["ID", "Model", "Views", "Clicks", "Regs", "Verified", "Revenue", "CTR", "Views:Reg", "Views:Verified", "Views:Sale"]
    const tableFieldName = ["id", "username", "total_views", "total_clicks", "total_regs", "total_ver", "total_rev", "model_ctr", "views_per_reg", "views_per_ver", "views_per_sale_ratio"]

    const [sortField, setSortField] = useState('model_ctr')
    const [sortDirection, setSortDirection] = useState(1)
    const tableID = "model"

    const [runStatus, setRunStatus] = useState(1)

    const categories = [
        {ID: "milf", NAME: "MILF"}, 
        {ID: "woman", NAME: "Woman"},
        {ID: "goddess", NAME: "Goddess"},
        {ID: "teen", NAME: "Teen"},
        {ID: "bbw", NAME: "BBW"},
        {ID: "asian", NAME: "Asian"},
        {ID: "ebony", NAME: "Ebony"},
        {ID: "granny", NAME: "Granny"},
        {ID: "gangbang", NAME: "Gangbang"},
        {ID: "massivetits", NAME: "Massive Tits"},
    ]

    useMemo(() => {
        const getDetails = async () => {
            if(toolID > 0) {
                const data = await toolsAPICall(tool_details, {'toolID': toolID, 'requester': userID, 'company': companyID })
                setTool(data.tool)
            }
        }
        getDetails()
    }, [toolID, userID, companyID])

    useEffect(() => {
        const getStats = async () => {
            if(toolID > 0) {
                setRunStatus(2)
                const data = await toolsAPICall(tool_bellacams, { 'requester': userID, 'company': companyID, 'startDate': Moment(startDate).format('YYYY-MM-DD'), 'endDate': Moment(endDate).format('YYYY-MM-DD') })
                setStats(data.stats)

                setRunStatus(0)
            }
        }
        if(runStatus === 1) {
            getStats()
        }
    }, [userID, companyID, runStatus, endDate, startDate])

    // const genRevReport = async (e) => {
    //     e.preventDefault()
    //     setRevCsvStatus(1)
    //     const csvData = await toolsAPICall(tool_lp_dashboard_data, { 'requester': userID, 'company': companyID, 'report': 1, 'subpid': curPid, 'geo': curGeo, 'devicetype': curDevice, 'answerid': curAnswer, 'startDate': Moment(startDate).format('YYYY-MM-DD'), 'endDate': Moment(endDate).format('YYYY-MM-DD'), 'cascadeType': cascadeType })
    //     if(csvData.revcsv) { 
    //         setRevCsv(csvData.revcsv)
    //         setRevCsvStatus(2)
    //     }
    // }

    // const genRegReport = async (e) => {
    //     e.preventDefault()
    //     setRegCsvStatus(1)
    //     const csvData = await toolsAPICall(tool_lp_dashboard_data, { 'requester': userID, 'company': companyID, 'report': 2, 'subpid': curPid, 'geo': curGeo, 'devicetype': curDevice, 'answerid': curAnswer, 'startDate': Moment(startDate).format('YYYY-MM-DD'), 'endDate': Moment(endDate).format('YYYY-MM-DD'), 'cascadeType': cascadeType })
    //     if(csvData.revcsv) { 
    //         setRegCsv(csvData.revcsv)
    //         setRegCsvStatus(2)
    //     }
    // }

    const tableData = (type) => {
        let values = stats

        // Sort values before mapping
        values = [...values].sort((a, b) => {
            // Always move "TOTAL" to the bottom
            if (a.path === "TOTAL") return 1;
            if (b.path === "TOTAL") return -1;

            let aValue = a[sortField];
            let bValue = b[sortField];

            // Convert to number if field is numeric
            if (['total_views','total_clicks','total_regs','total_ver','total_rev','model_ctr','views_per_reg','views_per_ver','views_per_sale_ratio'].includes(sortField)) {
                aValue = parseFloat(aValue);
                bValue = parseFloat(bValue);
            } else {
                aValue = String(aValue).toLowerCase();
                bValue = String(bValue).toLowerCase();
            }

            if (aValue < bValue) return sortDirection === 0 ? -1 : 1;
            if (aValue > bValue) return sortDirection === 0 ? 1 : -1;
            return 0;
        });

        let rows = [];
        values.forEach(row => {
            rows.push({'id': row.id, 'values': [
                row.id,
                row.username,
                row.total_views,
                row.total_clicks,
                row.total_regs,
                row.total_ver,
                row.total_rev ? '$' + parseFloat(row.total_rev).toFixed(4) : '',
                row.model_ctr ? parseFloat(row.model_ctr).toFixed(4) + '%' : '',
                row.views_per_reg,
                row.views_per_ver,
                row.views_per_sale_ratio
            ]});
        });
        return rows
    }

    const sortData = (field, direction) => {
        let index = tableFields.indexOf(field)

        setSortField(tableFieldName[index])
        setSortDirection(direction)
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(`${name} = ${value}`)
        setInputValue((prev) => ({
          ...prev,
          [name]: value,
        }));
    };
    
    const handleError = (field, error) => {
          setErrors((prev) => ({
              ...prev,
              [field]: error,
          }));
    };

    const filterDate = (field, value) => {
        if(field === 1) setStartDate(value)
        else if(field === 2) setEndDate(value)
    }

    const selectModel = (e) => {
        let rowID = e.currentTarget.id
        rowID = rowID.replace(`${tableID}_`, "")
        const foundItem = stats.find(item => item.id === rowID);
        setInputValue((prev) => ({
          ...prev,
          'modelID': rowID,
          'username': foundItem.username,
          'category': foundItem.category,
          'isActive': foundItem.is_active,
        }));
    }

    const saveModel = async (e) => {
        e.preventDefault()
        
        setFormMessage('')
        let formErrors = []
        for (const field of Object.entries(errors)) {
            const error = field[1]
            if(error.length > 0) formErrors.push(error)
        }
        if(formErrors.length > 0) { 
            setFormMessage(formErrors.join('<br/>'))
            return
        }

        if(username.length === 0) {
            formErrors.push("You must enter a Model Username")
        }
        if(category.length === 0) {
            formErrors.push("You must select a Category")
        }
        if(formErrors.length > 0) { 
            setFormMessage(formErrors.join('<br/>'))
            return
        }

        const data = await toolsAPICall(tool_bellacams_save, {
            'requester': userID, 
            'company': companyID, 
            'modelID': modelID, 
            'username': username, 
            'category': category, 
            'isActive': parseInt(isActive) === 1 ? 1 : 0, 
            'startDate': Moment(startDate).format('YYYY-MM-DD'), 
            'endDate': Moment(endDate).format('YYYY-MM-DD')
        })

        //if successful, delete from project object
        if(data.error) {
            setFormMessage(data.error)
            return
        } 
        else {
            if(data.stats) setStats(data.stats)
            setFormMessage("Model saved")
        }
    }

    const runFilter = async () => {
        //setRevCsv({}); setRevCsvStatus(0);
        //setRegCsv({}); setRegCsvStatus(0);
      
        setStats([]);
      
        setRunStatus(1)
      };

    if(!tool) return <></>

    if(!stats) return <>No Data</>

    return (
        <>
        <Breadcrumb>
          <Breadcrumb.Item href="/tools/">Tools</Breadcrumb.Item>
          <Breadcrumb.Item active>{tool.tool_name}</Breadcrumb.Item>
        </Breadcrumb>
        <Card>

        <CardHeader title={tool.tool_name} description={tool.description} />
                <Form description={tool.description} noCard={true} >
                    <Row>
                        <Col md={6}>
                            <strong>Filter Dates</strong>
                            <FormGroup>
                                <Row>
                                <FormLabel column sm="3" htmlFor={startDate}>Start Date</FormLabel>
                                <Col md={6}>
                                    <DatePicker id="startDate" name="startDate" selected={startDate} className="form-control" onChange={(date) => filterDate(1, date)} />
                                </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                <FormLabel column sm="3" htmlFor={endDate}>End Date</FormLabel>
                                <Col md={6}>
                                <DatePicker id="endDate" name="endDate" selected={endDate} className="form-control" onChange={(date) => filterDate(2, date)} />
                                </Col>
                                </Row>
                            </FormGroup>

                            <Button onClick={(e) => { e.preventDefault(); runFilter(); }} title="Filter Data" className="primary" /> 
                        </Col>
                        <Col md={6}>

                        <strong>{username?.length > 0 ? `Edit ${username}` : "Add Model"}</strong>
                            
                            <Input
                                type="text"
                                value={username}
                                placeholder="Model Username"
                                label="Model Username"
                                name="username"
                                onChange={handleChange}
                                onError={handleError}
                                readOnly={!canEdit || parseInt(modelID) > 0 ? true : false}
                                validate="text|required"
                                colSize="6"
                            />
                            
                            <Select
                                value={category}
                                label="Category"
                                name="category"
                                formValues={categories}
                                useDefault={true}
                                onChange={handleChange}
                                validate="text|required"
                                colSize="6"
                            />     
                            
                            <Select
                                value={isActive}
                                label="Actve?"
                                name="isActive"
                                formField="yesno"
                                useDefault={false}
                                onChange={handleChange}
                                validate="number|required"
                                colSize="6"
                            />     

                            {formMessage.length > 0 && <p>{formMessage}</p> }

                            <Button title="Save Model" className="primary" onClick={saveModel}  />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>

                        {runStatus === 2 && <Card.Body>Loading Data...</Card.Body> }
                        {runStatus === 0 && <>
                        <DataTable hover={true} tableID={tableID} fieldNames={tableFields} onClick={selectModel} dataRows={tableData(1)} tableSettings={tableTypes.None} hideTotal={true} sortData={sortData} defaultSortOrder={1} defaultSortColumn='Date' />
                        </>}
                        </Col>
                    </Row>
                </Form>
            </Card>
        </>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(BellaCamsTool), "Bella Cams Model Management"));